// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","li":"ProCon_li__aUNEJ","iconCol":"ProCon_iconCol__2z7pX","textCol":"ProCon_textCol__1lbuh"};